export default "__VITE_ASSET__BHp9mJjf__"